import React from 'react';
import PCBStepRequestPresenter from './PCBStepRequestPresenter';

const PCBStepRequestContainer = () => {
  return <PCBStepRequestPresenter />;
};

export default PCBStepRequestContainer;
